import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatSliderChange} from '@angular/material/slider';
import {AdService} from '@services/ad.service';
import {CommonService} from '@services/common.service';
import {Favorite} from '@models/favorite';
import {EMPTY_FAVORITE} from '@models/empty';
import {AuthenticationService} from '@services/authentification.service';

@Component({
    selector: 'app-renta',
    templateUrl: './renta.component.html',
    styleUrls: ['./renta.component.scss']
})
export class RentaComponent {

    favorite: Favorite = Object.assign({}, EMPTY_FAVORITE);
    backupFavorite: Favorite = Object.assign({}, EMPTY_FAVORITE);

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                public dialogRef: MatDialogRef<RentaComponent>,
                public adService: AdService,
                public authenticationService: AuthenticationService,
                public commonService: CommonService) {
        this.favorite = Object.assign({}, data.favorite);
        this.backupFavorite = Object.assign({}, data.favorite);
    }

    onNoClick(): void {
        this.dialogRef.close({favorite: this.backupFavorite});

    }

    onYesClick(): void {
        this.favorite = this.adService.updateValues(this.favorite);
        this.dialogRef.close({favorite: this.favorite});
    }

    onInputChange(event: MatSliderChange) {
        console.log('This is emitted as the thumb slides');
        console.log(event.value);
    }

    edit(event, fields = '') {
        if (fields === 'price') {
            // Set to null to calculate it
            this.favorite.notary_price = null;
        }
        if (fields === 'works_total') {
            this.favorite.works_square_price = null;
            this.favorite.works_help = -1;
        }

        if (this.authenticationService.currentUser.pro_plan == 'oikos') {
            if (fields === 'price') {
                this.favorite.other_fees = null;
            } else if (fields === 'works_help' || fields === 'works_square_price' || fields === 'works_total') {
                this.favorite.other_fees_work = null;
            }
        }
        this.favorite = this.adService.updateValues(this.favorite);
    }

    editLot(event, i, fields = '') {
        if (fields === 'works_total') {
            this.favorite.works_square_price = null;
            this.favorite.works_help = -1;
            this.favorite.lots[i].works_square_price = null;
            this.favorite.lots[i].works_help = -1;
        }
        this.favorite = this.adService.updateValues(this.favorite);
    }

    updateEfficiency(event: MatSliderChange) {
        // Frais de notaire inclus
        let priceTotal = Math.round(this.favorite.amount_rent * 12 / (this.favorite.efficiency_brut / 100));

        if (this.favorite.estate_sale === 'Neuf') {
            priceTotal -= this.favorite.works_total;
            this.favorite.price = Math.round(priceTotal / (1 + 0.025));
            this.favorite.notary_price = Math.round(this.favorite.price * 0.025);
        } else {
            priceTotal -= this.favorite.works_total;
            this.favorite.price = Math.round(priceTotal / (1 + 0.08));
            this.favorite.notary_price = Math.round(this.favorite.price * 0.08);
        }

        this.favorite = this.adService.updateValues(this.favorite);
    }

    updateEfficiencyNet(event: MatSliderChange) {
        // Frais de notaire inclus
        let priceTotal = Math.round(this.favorite.net_rent * 12 / (this.favorite.efficiency_net / 100));

        if (this.favorite.estate_sale === 'Neuf') {
            priceTotal -= this.favorite.works_total;
            this.favorite.price = Math.round(priceTotal / (1 + 0.025));
            this.favorite.notary_price = Math.round(this.favorite.price * 0.025);
        } else {
            priceTotal -= this.favorite.works_total;
            this.favorite.price = Math.round(priceTotal / (1 + 0.08));
            this.favorite.notary_price = Math.round(this.favorite.price * 0.08);
        }

        this.favorite = this.adService.updateValues(this.favorite);
    }
}
